import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import * as Icon from "ubs-icons";
import {COLOR} from "ubs-framework/v2/common/constant";
import useSocket from "../hooks/useSocket";
import {sendData} from "../../../store/actions";
import {showToastSuccess} from "ubs-framework/v2/common/function";
import {useSelector} from "react-redux";
import {isInApp} from "ubs-framework/v2/common/function";
import UPopup from "ubs-framework/v2/UPopup";

const UFilterDownload = React.memo((props) => {
    const _SOCKET_ID = useSelector(e => e.common.socketId);

    const [currentData, setCurrentData] = useState(null);
    const [closeMenu, setCloseMenu] = useState(false);

    const handleDownload = (data) => {
        if (!currentData && data?.data && data?.event?.length) {
            setCurrentData(data)
            setCloseMenu(true)
            sendData(data?.event, data?.data)
        }
    }

    const {off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case currentData?.event: {
                    setCurrentData(null)
                    if (res?.data?.socketId === _SOCKET_ID && res?.data?.url) window.open(res?.data?.url, isInApp() ? '_self' : '_blank')
                    showToastSuccess(res.data?.message)
                    break;
                }
                default:
                    return true;
            }
        }

    })

    useEffect(() => {
        refresh()
        return () => off()
    }, [currentData]);

    return (
        <React.Fragment>
            <UPopup
                params={{position: 'bottom right', on: ['click'], contentStyle: {zIndex: 10001}}}
                closeMenu={closeMenu}
                closeMenuOpen={() => setCloseMenu(false)}
                desc={<div className="u_popover" style={{minWidth: '165px'}}>
                    <ul className="u_more-member-popover">
                        {props?.data?.map(data => {
                            return <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => handleDownload(data)}>
                                {data?.type === 'XLS' && <Icon.XLS size={18} fill={COLOR.u_icon_bg}/>}
                                <p className="u_ml-8">{data?.label ? data?.label : `Download As ${data?.type}`}</p>
                            </li>
                        })
                        }
                    </ul>
                </div>}
            >
                <div className="u_filter">
                    <UPopup params={{className: "u_tooltip"}} desc={<span>{currentData ? 'Loading...' : 'Download'}</span>}>
                        {currentData ? (
                            <span className={`u_filter-icon`}><Icon.Preloader/></span>
                        ) : (
                            <p className="u_flex u_align-center u_cp">
                                <span className={`u_filter-icon`} onClick={handleDownload}>
                                    <Icon.Download fill={COLOR.u_icon_bg} size={18}/>
                                </span>
                                {props?.name}
                            </p>
                        )}
                    </UPopup>
                </div>
            </UPopup>
        </React.Fragment>
    );
});

UFilterDownload.propTypes = {
    data: PropTypes.object,
    name: PropTypes.string
};

UFilterDownload.defaultProps = {
    data: [],
    name: ''
}

export default UFilterDownload;
